import FacebookButton from './FacebookButton';
import GoogleButton from './GoogleButton';
import EmailButton from './EmailButton';

import { LOG_IN, SIGN_UP } from './ButtonWrapper';

const FACEBOOK = 'facebook';
const GOOGLE = 'google';
const EMAIL = 'email';

export {
  FacebookButton,
  GoogleButton,
  EmailButton,
  LOG_IN,
  SIGN_UP,
  FACEBOOK,
  GOOGLE,
  EMAIL
};
